<template>
  <div class="d-flex align-items-center">
    <PWAInstallButton />

    <template v-if="session">
      <h4 class="m-0" v-if="session.is_registration_complete">
        <div class="d-flex cursor-pointer" @click="goToProfile">
          {{ session.first_name }}
          <span class="fas fa-user-circle text-dark50 ms-2"></span>
        </div>
      </h4>
      <div v-else id="logout-btn">
        <LogoutItem />
      </div>
    </template>
    <template v-else>
      <router-link :to="$paths.login" id="nav-login-btn" class="btn btn-sm btn-dark">
        Entrar
      </router-link>
    </template>

    <PWAInstallModal />
  </div>
</template>

<script lang="ts" setup>
import { ISession } from '@/interfaces';
import LogoutItem from '../LogoutItem.vue';
import PWAInstallButton from '../PWAInstallButton.vue';
import PWAInstallModal from '../Modals/PWAInstallModal.vue';
import { useRouter } from 'vue-router';
import paths from '@/router/paths';

const router = useRouter();

defineProps<{
  session: ISession | null
}>()

const goToProfile = () => {
  router.push(paths.more.root);
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
